import { render, staticRenderFns } from "./RightTable.vue?vue&type=template&id=3a6a87f6"
import script from "./RightTable.vue?vue&type=script&lang=js"
export * from "./RightTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports